import Section from '../../Section/Section'
import { Heading } from '../../Text'
import LoanBlock from './LoanBlock'

export default function Loans({
    title,
    subHeading,
    description,
    reversed = false,
    image,
}) {
    return (
        <Section backgroundColor="#fff" pt={15} pb={30}>
            {title && (
                <Heading
                    align="center"
                    mb="60px"
                    color="#0d417d"
                    display={{
                        xs: 'none',
                        sm: 'none',
                        md: 'block',
                    }}
                >
                    {title}
                </Heading>
            )}
            <LoanBlock
                src={image?.url}
                alt={image?.alt}
                title={subHeading}
                reversed={reversed}
                description={description}
            />
        </Section>
    )
}
